import { FC, useMemo } from 'react'
// @ts-ignore
import { css } from '@emotion/react'
import styled from '@emotion/styled'

import { LibButton, LibButtonProps } from 'ui-components'

const StyledButton = styled(LibButton)<LibButtonProps>`
    white-space: nowrap;
    border-radius: 10px;

    @media (max-width: ${props => props.theme.bps.sm}) {
        padding: 0.5rem 0.75rem;
    }

    &.button-variant-outlined {
        ${({ theme, disabled }) => css`
            background-color: #242f3f;
            color: white;
            border: 1px solid white;
        `}
    }

    &.button-variant-filled {
        ${({ theme, disabled }) => css`
            background-color: ${disabled ? theme.colors.primaryDisabled : '#6f78f5'};
            color: ${theme.colors.white};
        `}
    }

    &.button-variant-plain {
        ${({ theme, disabled }) => css`
            background-color: #3c4656;
            color: white;
            border: 1px solid transparent;
        `}
    }
`

enum EButtonStyleVariantClass {
    Outlined = 'button-variant-outlined',
    Filled = 'button-variant-filled',
    Plain = 'button-variant-plain',
}

const getButtonVariantClass = ({ isOutlined, isBorderless }): EButtonStyleVariantClass => {
    if (isOutlined) {
        return EButtonStyleVariantClass.Outlined
    }
    if (isBorderless) {
        return EButtonStyleVariantClass.Plain
    }
    return EButtonStyleVariantClass.Filled
}

type TButtonProps = LibButtonProps & {
    styleVariant?: EButtonStyleVariantClass
    isOutlined?: boolean
    isBorderless?: boolean
}

const Button: FC<TButtonProps> = ({
    styleVariant,
    isOutlined = false,
    isBorderless = false,
    ...props
}) => {
    const variantClass: EButtonStyleVariantClass = useMemo(
        () => styleVariant || getButtonVariantClass({ isOutlined, isBorderless }),
        [styleVariant, isOutlined, isBorderless],
    )

    return <StyledButton className={variantClass} {...props} />
}

export type { TButtonProps }
export { EButtonStyleVariantClass, StyledButton }
export default Button
